<template>
	<div :class="['relative', containerStyle]">
		<div
			v-if="showControls"
			class="absolute flex items-center gap-5 md:right-2 right-1/2 md:-top-10 translate-x-1/2 md:translate-x-0 -bottom-10 md:bottom-auto"
		>
			<button
				type="button"
				aria-label="Prev Arrow Button"
				class="group hover:bg-stone-100 !p-2"
				@click="handlePrev"
				:disabled="disablePrev"
			>
				<svg-vue icon="embla-arrow" class="stroke-black rotate-180 group-disabled:stroke-stone-300" />
			</button>
			<button
				type="button"
				aria-label="Next Arrow Button"
				class="group hover:bg-stone-100 !p-2"
				@click="handleNext"
				:disabled="disableNext"
			>
				<svg-vue icon="embla-arrow" class="stroke-black group-disabled:stroke-stone-300" />
			</button>
		</div>
		<div ref="emblaRef" class="w-full overflow-hidden">
			<div class="backface-hidden flex touch-pan-y">
				<slot />
			</div>
		</div>
		<template v-if="showPagination">
			<template v-if="useDots">
				<ul class="!p-0 !m-0 flex justify-center gap-1 absolute bottom-1.5 left-1/2 -translate-x-1/2">
					<li
						v-for="slide of slideCount"
						:class="[
							'w-1.5 h-1.5 rounded-full bg-black/30 cursor-pointer',
							selectedScrollSnap === slide - 1 && '!bg-black/100',
						]"
						@click="() => goToIndex(slide - 1)"
					/>
				</ul>
			</template>
			<template v-else>
				<ul class="flex absolute left-1/2 -translate-x-1/2 -bottom-10">
					<li
						v-for="slide of slideCount"
						:class="['w-14 bg-black/20 h-0.5 cursor-pointer', selectedScrollSnap === slide - 1 && '!bg-black']"
						@click="() => goToIndex(slide - 1)"
					/>
				</ul>
			</template>
		</template>
	</div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import emblaCarouselVue from 'embla-carousel-vue'
import Autoplay from 'embla-carousel-autoplay'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

const props = defineProps({
	slideCount: {
		type: Number,
		required: true,
	},
	loop: {
		type: Boolean,
		default: false,
	},
	showControls: {
		type: Boolean,
		default: false,
	},
	showPagination: {
		type: Boolean,
		default: false,
	},
	autoPlay: {
		type: Boolean,
		default: false,
	},
	delay: {
		type: Number,
		default: 5000,
	},
	containerStyle: {
		type: String,
		default: '',
	},
	useDots: {
		type: Boolean,
		default: false,
	},
})

const { loop, autoPlay, delay } = props

const [emblaRef, emblaApi] = emblaCarouselVue(
	{ loop },
	[WheelGesturesPlugin(), autoPlay && Autoplay({ delay })].filter(Boolean)
)
const selectedScrollSnap = ref(0)
const disablePrev = ref(true)
const disableNext = ref(false)

onMounted(() => {
	if (emblaApi.value) {
		emblaApi.value.on('scroll', () => {
			selectedScrollSnap.value = emblaApi.value.selectedScrollSnap()
			disablePrev.value = !emblaApi.value.canScrollPrev()
			disableNext.value = !emblaApi.value.canScrollNext()
		})
	}
})

const goToIndex = (index) => emblaApi.value.scrollTo(index)
const handlePrev = () => emblaApi.value.scrollPrev()
const handleNext = () => emblaApi.value.scrollNext()
</script>
